import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

export const webhookManagementSection: MenuItem[] = [
  {
    headTitle1: 'Webhook Management',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
  },
  {
    title: 'Reference',
    icon: 'file-text',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    children: [
      {
        title: 'Webhook Guide',
        path: '/webhook-management/guide',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
      },
      {
        title: 'Webhook Events',
        path: '/webhook-management/event-types',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
      },
      {
        title: 'Webhook Payloads',
        path: '/webhook-management/payloads',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
      },
      {
        title: 'Webhook Auth Methods',
        path: '/webhook-management/authentication-methods',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
      },
    ],
  },
  {
    title: 'Configuration',
    icon: 'settings',
    path: '/webhook-management/configurations',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
  },
  {
    title: 'Monitoring',
    icon: 'monitor',
    path: '/webhook-management/monitoring',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
  },
  {
    // ryd internal: Circle K PCS wash sales (TASKFORCE-3034).
    title: 'Circle K PCS',
    icon: 'stroke-station-management',
    iconf: 'fill-station-management',
    type: 'sub',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.bmw_circle_k_pcs],
    children: [
      {
        title: 'Stations',
        path: '/webhook-management/circle-k-pcs-stations',
        // The add and edit pages (new tab) keep this entry active.
        activePathPrefixes: ['/webhook-management/circle-k-pcs-stations/'],
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.bmw_circle_k_pcs],
      },
      {
        title: 'Monitoring',
        path: '/webhook-management/circle-k-pcs-monitoring',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.bmw_circle_k_pcs],
      },
      {
        title: 'How It Works',
        path: '/webhook-management/circle-k-pcs-how-it-works',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.bmw_circle_k_pcs],
      },
    ],
  },
];
